export const isValidCoordinate = (value: number | null | undefined): value is number => {
  if (value === null || value === undefined) return false;
  if (Number.isNaN(value)) return false;
  if (value === -1) return false;
  return true;
};

export const isValidCoordinatesPair = (
  lat: number | null | undefined,
  lng: number | null | undefined
): lat is number => isValidCoordinate(lat) && isValidCoordinate(lng);

const calculateDistanceBetweenCoordinates = (
  x1: number,
  y1: number,
  x2: number,
  y2: number
): number | null => {
  if (!isValidCoordinatesPair(x1, y1) || !isValidCoordinatesPair(x2, y2))
    return null;

  const R = 6371;
  const dX = toRadians(x2 - x1);
  const dY = toRadians(y2 - y1);

  const a =
    Math.sin(dY / 2) * Math.sin(dY / 2) +
    Math.cos(toRadians(y1)) *
      Math.cos(toRadians(y2)) *
      Math.sin(dX / 2) *
      Math.sin(dX / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c;

  return distance;
};

const toRadians = (degree: number): number => {
  return degree * (Math.PI / 180);
};
export default calculateDistanceBetweenCoordinates;
